module.exports = __webpack_public_path__ + "media/images/category/feature/coj_d/coj_d-3-4b59f01c9e2abe80696723256e286d71.jpg";